import { assessCostCoverage, COST_COVERAGE_COPY, type SimulationPublic } from '@repo/shared'

/** 원가 줄에 보일 값. 단가가 빈 칸이 있으면 합계·마진 대신 보류 문구 */
export type AdminCostView =
  { held: false; totalPerUnit: number; marginPct: number } | { held: true; label: string }

/**
 * 시뮬레이션 상세의 개당 원가·마진. 단가가 빈 재료는 0원으로 합계에 들어가 마진이 실제보다 높게 보이므로,
 * 고객 앱과 같은 판정(assessCostCoverage)이 모자라다고 하면 보류한다. 다 있으면 저장된 값 그대로 (C17)
 */
export function adminCostView(
  result: Pick<SimulationPublic, 'ingredients' | 'costs' | 'pricing'>,
): AdminCostView {
  const coverage = assessCostCoverage(result)
  if (coverage.complete) {
    return {
      held: false,
      totalPerUnit: result.costs.totalPerUnit,
      marginPct: Math.round(result.pricing.marginPct * 100),
    }
  }
  const gaps = [
    coverage.missingIngredients > 0 ? `단가 빈 재료 ${coverage.missingIngredients}개` : null,
    coverage.packagingKnown ? null : '포장 단가 없음',
    coverage.laborKnown ? null : '인건비 없음',
  ].filter(Boolean)
  return { held: true, label: `보류 (${[COST_COVERAGE_COPY.ko.missing, ...gaps].join(' · ')})` }
}

/** 자동 점검 탭 머리말. 기준 충족은 형식 점검일 뿐이라 '통과' 라고 쓰지 않는다 */
export const AUTO_CHECK_RULE =
  '코드 검사가 전부 ✓ 이고 AI 점검 점수가 모두 3 이상이면 자동 형식 점검 기준을 충족해요.'

/** AI 점검 점수 옆 괄호 글 */
export const AI_JUDGE_SCORE_RULE = '1~5, 3 이상이면 자동 형식 점검 기준 충족'

/** AI '안전' 점수를 운영자가 안전 확인으로 읽지 않게. 화면에는 점수 옆 한 곳에만 둔다 */
export const AI_JUDGE_SAFETY_NOTE =
  '안전 점수는 AI 가 초안을 읽고 매긴 점수이며 안전 확인이 아니에요.'
